export default class SettingsExpertisesController {
  onProfileSave(proficiencies) {
    this.settings.profile.proficiencies_attributes = proficiencies;

    return this.settings.profile.$update();
  }
}



// WEBPACK FOOTER //
// ./src/app/screens/engineer/screens/settings/screens/settings-expertises/settings-expertises.controller.js